import React from "react";
import AR1 from "../../Assessts/Images/Publications/AnnualReports/AR1.png";
import AR2 from "../../Assessts/Images/Publications/AnnualReports/AR2.png";
import AR3 from "../../Assessts/Images/Publications/AnnualReports/AR3.png";
import { Row, Col } from "react-bootstrap";
import { Images } from "../../ReUableComponents/CommonElements";
const AnnualReports = () => {
       const AReports = [{ Img: AR1, Name: "NSF Annual Report 2022–23" },
    { Img: AR2, Name: "NSF Annual Report 2023–24" },
    { Img: AR3, Name: "NSF Annual Report 2024–25" },]
     const OPenPDF = (index) => {
        switch (index) {
            case 0: window.open("./PDFS/AnnualReports/NSF Annual report 2022-23.pdf", "_blank", "noopener,noreferrer");
                break;
            case 1: window.open("../PDFS/AnnualReports/NSF Annual report 2023-24.pdf", "_blank", "noopener,noreferrer");
                break;
            case 2: window.open("../PDFS/AnnualReports/NSF Annual report 2024-25.pdf", "_blank", "noopener,noreferrer");
                break;
        }
    };
    return (
        <div className="m-4">
        <div className="Web-MainHeading mt-3 mb-3">Annual Reports</div>

            <div className="container-fluid">
                <Row className="dflex gap-2">
                    {AReports.map((item, index) => (<>
                        <Col className="dflex flexd-column alignitems ">
                            <div className="CPointer" onClick={() => OPenPDF(index)}><Images Image={item.Img} Name={item.Name} SpanClass="Web-SubHeading"/></div></Col>
                    </>))}
                </Row>
            </div>
        </div>
    )
}
export default AnnualReports;